export default "__VITE_ASSET__D96SwohF__"